import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'quotaholders-management',
    path: '/quotaholders',
    component: () => import(/* webpackChunkName: "quotaholders" */ '../components/quotaholders/QuotaholdersManagement.vue'),
  },
] as RouteConfig[];
